import type { MySqlQueryRecordFormValues, QueryFormState, SelectOption } from "../types";

/** 移动端断点（px）。 */
export const mobileBreakpoint = 768;

/** 平板断点（px）。 */
export const tabletBreakpoint = 1280;

/** 列表默认排序字段。 */
export const defaultSortField = "created_at";

/** 列表默认排序方向。 */
export const defaultSortDirection = "desc";

/** 列表查询缓存新鲜时间（毫秒）。 */
export const mySqlQueryListStaleTimeMs = 5000;

/** 列表筛选默认值。 */
export const defaultFormState: QueryFormState = {
  recordName: "",
  source: "",
  tags: [],
  bizDate: "",
  createdRange: [],
  enabledOnly: true,
};

/** 记录弹窗默认表单值。 */
export const defaultRecordFormValues: MySqlQueryRecordFormValues = {
  recordName: "",
  source: "",
  tags: [],
  bizDate: "",
  amount: undefined,
  enabled: true,
};

/** 标签下拉选项。 */
export const tagOptions: SelectOption[] = [
  { label: "高优先级", value: "high_priority" },
  { label: "已归档", value: "archived" },
  { label: "待复核", value: "pending_review" },
  { label: "新客户", value: "new_customer" },
];

/** 来源下拉选项。 */
export const sourceOptions: SelectOption[] = [
  { label: "系统导入", value: "system_import" },
  { label: "手工创建", value: "manual_create" },
  { label: "API 同步", value: "api_sync" },
];

/** 每页条数选项。 */
export const pageSizeOptions = [10, 20, 50, 100];

/** 每页条数下拉格式化选项。 */
export const pageSizeSelectOptions: SelectOption[] = pageSizeOptions.map((option) => ({
  label: `${option} 条`,
  value: option,
}));
